<div class="add-product-page">
  <div class="container">
    <h2>{{ 'quoteCart.addProductFormHeading' | cxTranslate }}</h2>

    <form [formGroup]="quoteForm">
      <div class="row">
        <div class="col-md-4 mt-15">
          <div class="vs-text-field">
            <label
              >{{ 'quoteCart.partNumberLabel' | cxTranslate }}
              <span class="star">*</span></label
            >
            <input
              #partNumberInput
              type="text"
              formControlName="partNumber"
              placeholder="{{
                'quoteCart.partNumberPlaceholder' | cxTranslate
              }}"
              (focus)="
                $event.stopPropagation();
                $event.preventDefault();
                searchProducts($event, false)
              "
              (clickOutside)="close($event)"
              (keyup.enter)="searchProducts($event, true)"
              onblur="this.placeholder = 'Part Number Here'"
              class="float-left"
              (input)="searchProducts($event, false)"
              [class.error]="
                this.submitted &&
                !this.f['partNumber'].disabled &&
                this.f['partNumber'].invalid
              "
            />
            <div
              *ngIf="showSearchLoader"
              class="product-search-spinner cx-spinner"
            >
              <cx-spinner></cx-spinner>
            </div>

            <a
              *ngIf="catalogProductSelected || isEnter"
              (click)="clearForm()"
              class="clear-form-btn float-left rounded-circle"
              ><i class="material-icons close-icon" matTooltip="">close</i></a
            >

            <label
              class="error float-left"
              *ngIf="
                this.submitted &&
                !this.f['partNumber'].disabled &&
                this.f['partNumber'].invalid
              "
            >
              {{ 'quoteCart.errorModelNo' | cxTranslate }}
            </label>
            <label class="error float-left" *ngIf="part_error"
              >{{ this.f.partNumber.value }} is not a valid entry for quote
              cart. Please enter correct part number.</label
            >
            <div *ngIf="view && products?.length" class="searchProducts">
              <ng-container *ngFor="let product of products">
                <a
                  *ngIf="!product.hideButton"
                  class="listProducts"
                  (click)="populateFields(product)"
                  #partNumberList
                >
                  <div class="row" (click)="populateFields(product)">
                    <div class="col-3 p-0 product-image">
                      <cx-media
                        class="rfqSearchTumbnail"
                        [container]="getProductImage(product)"
                        [alt]="product.summary"
                      >
                      </cx-media>
                    </div>

                    <div class="col-9 p-0 product-details">
                      <p class="name product-code">{{ product.code }}</p>
                      <p
                        class="name font-wet"
                        [innerHTML]="product.name"
                        matTooltipClass="vs-tooltip"
                        [matTooltip]="parseHtmlText(product.name)"
                      ></p>
                      <div
                        *ngIf="product.newLegacyMaterial"
                        class="text-warning legacy-text"
                      >
                        <span class="material-icons">warning </span
                        >{{ 'quoteCart.replacementPartFor' | cxTranslate }}
                        {{ product.newLegacyMaterial }}
                      </div>
                    </div>
                  </div>
                </a>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="!part_error && ((!catalogue && view && populated) || populated)"
      >
        <p
          class="errorMsgBlc product-warning-info"
          *ngIf="
            (!catalogProductSelected &&
              !catalogue &&
              !productsListAvailable &&
              products.length === 0 &&
              this.f.partNumber.value.length > 0) ||
            (!catalogProductSelected &&
              !catalogue &&
              !productsListAvailable &&
              isEnter)
          "
        >
          <i class="material-icons info help"> info </i>
          <span>
            {{ 'quoteCart.errorMatching' | cxTranslate }}
          </span>
        </p>
        <ng-container *ngIf="isShowForm && this.f.partNumber.value.length > 0">
          <div *ngIf="!catalogProductSelected" class="row">
            <div class="col-md-8">
              <p class="text-content">
                {{ 'quoteCart.productTypeLabel' | cxTranslate }}
                <span class="star">*</span>
              </p>
              <div class="vs-radio-button row" #productTypeError>
                <div class="col-md-3 col-sm-6 col-xs-6">
                  <input
                    id="agree-radio"
                    type="radio"
                    value="equipment"
                    name="productType"
                    formControlName="productType"
                    autofocus
                  />
                  <label for="agree-radio">{{
                    'quoteCart.productType1' | cxTranslate
                  }}</label>
                  <i
                    class="material-icons help"
                    matTooltipClass="vs-tooltip"
                    matTooltip="{{
                      'quoteCart.equipmentTooltipTxt' | cxTranslate
                    }}"
                    >help</i
                  >
                </div>

                <div class="col-md-3 col-sm-6 col-xs-6">
                  <input
                    id="disagree-radio"
                    type="radio"
                    value="part"
                    name="productType"
                    formControlName="productType"
                    autofocus
                  />
                  <label for="disagree-radio">{{
                    'quoteCart.productType2' | cxTranslate
                  }}</label>
                  <i
                    class="material-icons help"
                    matTooltipClass="vs-tooltip"
                    matTooltip="{{ 'quoteCart.partTooltipTxt' | cxTranslate }}"
                    >help</i
                  >
                </div>
              </div>
              <label
                class="error product-type-error mt-10"
                *ngIf="this.submitted && !this.f.productType.valid"
                >{{ 'quoteCart.productTypeSelect' | cxTranslate }}</label
              >
            </div>
          </div>

          <div class="row mt-30">
            <div
              class="col-md-4"
              *ngIf="
                (productTypeName.toLowerCase().includes('parts') ||
                  productTypeName.toLowerCase().includes('part')) &&
                (this.f.productType.value.toLowerCase().includes('part') ||
                  this.f.productType.value.toLowerCase().includes('parts'))
              "
            >
              <div class="vs-text-field">
                <label
                  >{{ 'quoteCart.serialNumberLabel' | cxTranslate }}
                  <span *ngIf="productType == 'part'" class="star">*</span>
                </label>
                <input
                  type="text"
                  placeholder="{{
                    'quoteCart.serialNumberPlaceholder' | cxTranslate
                  }}"
                  maxlength="200"
                  formControlName="serialNumber"
                  [class.error]="
                    this.submitted &&
                    !this.f.serialNumber.disabled &&
                    this.f.serialNumber.invalid
                  "
                />
                <label
                  class="error"
                  *ngIf="this.submitted && this.f.serialNumber.invalid"
                  >{{ 'quoteCart.selectSerialNumError' | cxTranslate }}</label
                >
              </div>
            </div>

            <div class="col-md-4">
              <div class="vs-text-field">
                <label class="product-type-label"
                  >{{ 'quoteCart.partDescription' | cxTranslate }}
                  <span class="star">*</span></label
                >
                <div
                  matTooltipClass="vs-tooltip"
                  [matTooltip]="getPartDescTooltip(partDescription)"
                >
                  <input
                    type="text"
                    [innerHTML]="partDescription"
                    formControlName="partDescription"
                    maxlength="40"
                    placeholder="{{
                      'quoteCart.partDescription' | cxTranslate
                    }}"
                    [class.error]="
                      this.submitted &&
                      !this.f.partDescription.disabled &&
                      this.f.partDescription.invalid
                    "
                    [disabled]="catalogue ? true : false"
                  />
                </div>
                <label
                  class="error"
                  *ngIf="
                    this.submitted &&
                    !this.f.partDescription.disabled &&
                    this.f.partDescription.invalid
                  "
                >
                  {{ 'quoteCart.pleaseEnter' | cxTranslate }}
                  {{ productType.toLowerCase() }}
                  {{ 'quoteCart.description' | cxTranslate }}</label
                >
              </div>
            </div>

            <div class="col-md-4">
              <div class="dropdown-container">
                <label
                  >{{ 'quoteCart.brandLabel' | cxTranslate }}
                  <span class="star">*</span>
                </label>
                <ng-select
                  [searchable]="false"
                  [clearable]="false"
                  placeholder="{{ 'quoteCart.brandSelect' | cxTranslate }}"
                  class="brand-dropdown"
                  formControlName="brand"
                  id="brand"
                  [class.error]="
                    this.submitted &&
                    !this.f.brand.disabled &&
                    this.f.brand.invalid
                  "
                >
                  <ng-option
                    *ngFor="let brand of this.brandList"
                    [value]="brand.code"
                  >
                    {{ brand.name }}
                  </ng-option>
                </ng-select>
                <label
                  class="error"
                  *ngIf="
                    this.submitted &&
                    !this.f.brand.disabled &&
                    this.f.brand.invalid
                  "
                  >{{ 'quoteCart.selectBrandError' | cxTranslate }}</label
                >
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 mt-15">
              <div class="vs-text-field">
                <label>{{ 'quoteCart.tagNumberLabel' | cxTranslate }}</label>
                <input
                  type="text"
                  placeholder="{{
                    'quoteCart.tagNumberPlaceholder' | cxTranslate
                  }}"
                  formControlName="tagNumber"
                  maxlength="35"
                />
              </div>
            </div>
          </div>

          <h2 class="mt-35">
            {{ 'quoteCart.additionalDetailsLabel' | cxTranslate }}
          </h2>

          <div class="row">
            <div class="col-md-4">
              <div class="vs-text-field">
                <label class="mt0"
                  >{{ 'quoteCart.quantityLabel' | cxTranslate }}
                </label>
                <div class="d-flex">
                  <vs-item-counter
                    [control]="quoteForm.get('quantity')"
                    [max]="9999"
                  >
                  </vs-item-counter>
                  <span class="eachText" *ngIf="catalogProductSelected">{{
                    uom
                  }}</span>
                </div>

                <!-- <span class="eachText" *ngIf="!catalogProductSelected">{{
                  "quoteCart.each" | cxTranslate
                }}</span> -->
              </div>
            </div>
            <div class="col-md-4">
              <div class="dropdown-container">
                <label>{{
                  'quoteCart.reasonForQuoteLabel' | cxTranslate
                }}</label>
                <ng-select
                  [searchable]="false"
                  [clearable]="false"
                  placeholder="{{
                    'quoteCart.selectPlaceholder' | cxTranslate
                  }}"
                  class="reasonforQuote"
                  formControlName="reasonforQuote"
                >
                  <ng-option
                    *ngFor="let reason of this.reasonForQuote; let i = index"
                    [value]="reason.code"
                    ng-selected="reason.code == this.reasonForQuote[0].code"
                  >
                    {{ reason.name }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>
          <!-- <div class="row mt20"> -->
          <!-- <div class="col-md-4">
              <div class="vs-text-field">
                <label
                  >{{ "quoteCart.customerRequestDateLabel" | cxTranslate }}
                  <span class="star">*</span></label
                >
                <vs-date-picker
                  class="add-product-date-picker"
                  (selectedDate)="dateChange($event)"
                  [defaultDate]="this.f.customerRequestedDate.value"
                  [min]="minDate"
                  [filterWeekend]="filterWeekend"
                >
                </vs-date-picker>
                <label
                  class="error"
                  *ngIf="this.submitted && !this.f.customerRequestedDate.valid"
                  >{{ "quoteCart.errorShipDate" | cxTranslate }}</label
                >
              </div>
            </div> -->
          <!-- <div class="col-md-4">
              <div class="dropdown-container">
                <label>{{
                  "quoteCart.reasonForQuoteLabel" | cxTranslate
                }}</label>
                <ng-select
                  [searchable]="false"
                  [clearable]="false"
                  placeholder="Select"
                  class="reasonforQuote"
                  formControlName="reasonforQuote"
                >
                  <ng-option
                    *ngFor="let reason of this.reasonForQuote; let i = index"
                    [value]="reason.code"
                    ng-selected="reason.code == this.reasonForQuote[0].code"
                  >
                    {{ reason.name }}
                  </ng-option>
                </ng-select>
              </div>
            </div> -->
          <!-- </div> -->
          <div class="row">
            <div class="col-md-8">
              <div class="vs-text-area">
                <label>{{ 'quoteCart.commentsLabel' | cxTranslate }}</label>
                <textarea
                  formControlName="comment"
                  [ngClass]="
                    cartStatus === 'adding' ? 'comment-width1' : 'comment-width'
                  "
                  maxlength="255"
                ></textarea>
                <label
                  *ngIf="this.f.comment.value"
                  class="mt-0 char-limit char-limit-count"
                  >{{ 'quoteCart.remainingChar' | cxTranslate }} -
                  {{ 255 - this.f.comment.value.length }}</label
                >
              </div>
            </div>
          </div>

          <div class="row text-right mt-15">
            <div class="col-md-8"></div>
            <div class="col-md-4 text-right">
              <button class="vs-text-btn cancel" (click)="cancel()">
                {{ 'quoteCart.cancel' | cxTranslate }}
              </button>
              <button
                class="vs-primary-btn done"
                (click)="addProduct()"
                [disabled]="showAddProductLoader"
              >
                <span>{{ 'quoteCart.done' | cxTranslate }}</span>
                <div
                  *ngIf="showAddProductLoader"
                  class="availability-spinner float-right cx-spinner"
                >
                  <cx-spinner></cx-spinner>
                </div>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>
</div>
